<!-- 9 -->
<template>
  <div>
    <TemplateDbsMyUsing
      v-if="isReadyToDraw"
      :prop-my-reservation="myReservation"
      :prop-utilization-time="utilizationTime"
    />
    <DialogInitialLoading v-else />
  </div>
</template>

<script>
import { onMounted, computed, ref, watch } from "vue";
import { useStore } from "vuex";

import API from "@/API";

import nativeHandlerService from "@/services/nativeHandler";
import TemplateDbsMyUsing from "@/views/Templates/Dbs/TemplateDbsMyUsing";

export default {
  name: "DbsMyUsing",
  components: {
    TemplateDbsMyUsing,
  },
  setup() {
    const store = useStore();
    const myReservation = computed(() => store.getters["dbs/reservation"]);

    // 利用時間
    let utilizationTime = ref(null);

    const isReadyToDraw = ref(false);

    // インターバル用変数
    const getInfoInterval = ref(null);
    const utilizationTimeInterval = ref(null);

    onMounted(async () => {
      // 必要なAPI取得して全てmyReservationに集約
      await API.getDbsReservation();
      await API.getDbsReportsForUsing();

      if (myReservation.value.status == "started") {
        // 10秒ごとに予約状況確認API
        getInfoInterval.value = setInterval(async () => {
          await API.getDbsReservation();
          if (myReservation.value.status == "none") {
            await API.getDbsReportsForUsing();
          }
        }, 10000);

        // 1秒ごとに利用時間のカウントアップ
        utilizationTimeInterval.value = setInterval(() => {
          updateUtilizationTime();
        }, 1000);
      }

      isReadyToDraw.value = true;
    });

    // 利用時間のカウントアップ
    const updateUtilizationTime = () => {
      const startUsing = new Date(myReservation.value.start_time);
      const now = new Date();
      // 利用開始時間と現在時間を引数
      utilizationTime.value = returnStringHMS(startUsing, now);
    };

    // 起点時間と比較対象時間の差異をhh:mm:ssで返す
    const returnStringHMS = (startPoint, comparisonPoint) => {
      const datet = parseInt(
        (comparisonPoint.getTime() - startPoint.getTime()) / 1000
      );
      let hour = parseInt(datet / 3600);
      let min = parseInt((datet / 60) % 60);
      let sec = datet % 60;
      // 数値が1桁の場合、頭に0を付けて2桁で表示する指定
      if (hour < 10) {
        hour = "0" + hour;
      }
      if (min < 10) {
        min = "0" + min;
      }
      if (sec < 10) {
        sec = "0" + sec;
      }
      return `${hour}:${min}:${sec}`;
    };

    // myReservationを監視して、新しい値が予約なしになったらインターバルをストップ
    watch(myReservation, (newVal) => {
      if (newVal.status == "none") {
        clearInterval(getInfoInterval.value);
        clearInterval(utilizationTimeInterval.value);
        // 利用開始時間と利用終了時間を引数
        utilizationTime.value = returnStringHMS(
          new Date(myReservation.value.start_time),
          new Date(myReservation.value.end_time)
        );
      }
    });

    return {
      isReadyToDraw,
      myReservation,
      utilizationTime,
    };
  },
};
</script>
